"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderContext = void 0;
exports.PlaceholderContextProvider = PlaceholderContextProvider;
exports.usePlaceholderContext = usePlaceholderContext;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.PlaceholderContext = (0, react_1.createContext)(undefined);
function PlaceholderContextProvider(_a) {
    var value = _a.value, children = _a.children;
    return (react_1.default.createElement(exports.PlaceholderContext.Provider, { value: value }, children));
}
function usePlaceholderContext() {
    var ctx = (0, react_1.useContext)(exports.PlaceholderContext);
    if (!ctx) {
        throw new Error("Your component should be wrapped in a 'PlaceholderContextProvider' to use the 'usePlaceholderContext' hook.");
    }
    return ctx;
}
//# sourceMappingURL=PlaceholderProvider.js.map